import React from 'react'
import "./Components.css";


const Author = () => {
  return (
    <div className='author-container'>
    <p>&copy; Zuzim Ajo 2022</p>
    </div>
  )
}

export default Author